<template>
  <div style="matgin-bottom: 10px;background:#f6f6f6">
    <div class="product-header">
      <img src="https://enited-static-resources.oss-accelerate.aliyuncs.com/static/1561686560047.jpg" />
      <div 
      class="title1">数智优选</div>
      <div class="title2">DATA-DRIVEN TECHNOLOGY</div>
      <div class="mkdir" :class="{ 'before-mkidr': tabbarBoxFixed }"></div>
    </div>

    <div class="product-content">
      <div class="poduct wow bounceInLeft">PODUCTS</div>
      <div class="menu-content">
        <div class="menu wow bounceInLeft">
          <div v-for="(item,index) in menulist" :key="item" class="menu-text" 
          :class="{ 'before-menu': menuIndex == index }"
          @click="onMenu(index)"
         >{{item}}</div>
        </div>
        <div class="line"></div>
        <div class="content">
          <div v-show="menuIndex == 0" 
           class="content-item  wow bounceInRight">
              <div class="item-top">
                    <div class="item-img">
                        <img class="img1" src="../assets/images/zhishe.png">
                        <div class="desc">
                          温馨提示：外观包装仅供参考；请仔细阅读说明书并在医师指导下使用。
                        </div>

                        <div class="button-item" @click="onAdd">
                            立即咨询
                        </div> 
                    </div>
                    <div class="item-desc">
                      <div class="desc-title">蛭蛇通络胶囊(久正)</div>
                      <div class="desc-tag">
                        <div class="tag">处方药</div>
                        <div class="piwen">【批准文号】国药准字Z20090658</div>
                      </div>
                      <div class="desc-details">
                        <div class="details-title">功能主治：</div>
                        <div class="details-content">益气活血，息风通络。用于中风病中经络(轻中度脑梗 塞)恢复期气虚血瘀证。症见半身不遂，偏身麻木，口 舌歪斜，舌强语蹇，自汗、气短乏力，脉沉细涩或弦。</div>
                      </div>

                       <div class="desc-details">
                        <div class="details-title">主要成分：</div>
                        <div class="details-content">黄芪、人参、天麻、丹参、红花、葛根、川芎、石菖 蒲、郁金、水蛭、冰片、乌梢蛇。</div>
                      </div>

                       <div class="desc-details">
                        <div class="details-title">不良反应：</div>
                        <div class="details-content">在使用过程中可能出现恶心、呕吐、胃不适、腹痛、 腹胀、皮疹、瘙痒、头晕等症状。</div>
                      </div>

                       <div class="desc-details">
                        <div class="details-title">功能主治：</div>
                        <div class="details-content">益气活血，息风通络。用于中风病中经络(轻中度脑梗 塞)恢复期气虚血瘀证。症见半身不遂，偏身麻木，口 舌歪斜，舌强语蹇，自汗、气短乏力，脉沉细涩或弦。</div>
                      </div>

                       <div class="desc-details">
                        <div class="details-title">禁忌：</div>
                        <div class="details-content">在使用过程中可能出现恶心、呕吐、胃不适、腹痛、 腹胀、皮疹、瘙痒、头晕等症状。</div>
                      </div>

                       <div class="desc-details">
                        <div class="details-title">有效期：</div>
                        <div class="details-content">24个月</div>
                      </div>

                       <div class="desc-details">
                        <div class="details-title">生产企业：</div>
                        <div class="details-content">陕西健民制药有限公司</div>
                      </div>
                    </div>
              </div>

              <div class="item-bottom">
                <div class="item1">
                  <div class="btitle">产品剂型</div>
                  <div>胶囊</div>
                </div>
                <div class="bottom-line"></div>
                <div class="item2">
                  <div class="btitle">规格</div>
                  <div>每粒装0.5g</div>
                </div>
                <div class="bottom-line"></div>
                <div class="item3">
                  <div class="btitle">用法用量</div>
                  <div>口服。一次4粒，一日3次，疗程4周。 副本 2</div>
                </div>
              </div>
          </div>

            <div v-show="menuIndex == 0" class="content-item  wow bounceInRight">
              <div class="item-top">
                    <div class="item-img">
                        <img class="img2" src="../assets/images/xinmaizhushe.png">
                        <div class="desc">
                          温馨提示：外观包装仅供参考；请仔细阅读说明书并在医师指导下使用。
                        </div>

                        <div class="button-item" @click="onAdd">
                            立即咨询
                        </div> 
                    </div>
                    <div class="item-desc">
                      <div class="desc-title">心脉隆注射液</div>
                      <div class="desc-tag">
                        <div class="tag">处方药</div>
                        <div class="piwen">【批准文号】国药准字Z20060443</div>
                      </div>
                      <div class="desc-details">
                        <div class="details-title">功能主治：</div>
                        <div class="details-content">益气活血，通阳利水。为慢性心衰的辅助用药。可用 于改善气阳两虚，瘀血内阻的慢性充血性心力衰竭引 起的心悸、浮肿、气短、面色晦暗、口唇发绀等症状。</div>
                      </div>

                       <div class="desc-details">
                        <div class="details-title">主要成分：</div>
                        <div class="details-content">心脉隆浸膏（复合核苷碱基、结合氨基酸）。辅料为 药用聚乙二醇、药用氯化钠。</div>
                      </div>

                       <div class="desc-details">
                        <div class="details-title">不良反应：</div>
                        <div class="details-content">尚不明确</div>
                      </div>


                       <div class="desc-details">
                        <div class="details-title"><span>禁</span><span>忌：</span></div>
                        <div class="details-content">1.皮试阳性者或已知对蜚蠊过敏和对本品过敏者禁用。 2.孕妇、哺乳期、严重肝肾功能不全和有严重出血倾 向者禁用。 3.用药期间出现皮疹者宜停用。</div>
                      </div>

                     
                         <div class="desc-details">
                        <div class="details-title">注意事项：</div>
                        <div v-if="!isShow" class="details-content">1.使用前应先做皮试（皮试方法见注意事项4），皮试呈阳性反应者，禁用。皮试呈阴性者，在用药过程中也应密切观察患者，如果出现...<span style="color:#0EADB1;cursor: pointer" @click="onshow(1)">展开</span>
                        </div>

                          <div v-if="isShow" class="details-content" @click="onhide(1)">1.使用前应先做皮试（皮试方法见注意事项4），皮试呈阳性反应者，禁用。皮试呈阴性者，在用药过程中也应密切观察患者，如果出现任何类型的过敏反应或病人主诉与过敏相关的不适，应立即停药并进行积极救治。2.本品应该在医生指导下应用。3.本品为慢性心衰的辅助用药，需在配合其它常规治疗的基础上使用。4.皮试方法暂定为：取心脉隆注射液0.1ml用生理盐水稀释1000倍制成皮试液，在前臂内侧皮内注射皮试液0.1ml，观察20分钟，若皮丘直径超过1厘米，为阳性反应，皮肤无红肿或虽有轻微红肿但直径小于1厘米者为阴性反应。呈阴<span style="color:#0EADB1;cursor: pointer;marginLeft:20px">收起</span>
                        </div>
                      </div>

                        <div class="desc-details">
                        <div class="details-title"><span>有</span><span style="flex:1;textAlign:center">效</span><span>期：</span></div>
                        <div class="details-content">30个月</div>
                      </div>


                       <div class="desc-details">
                        <div class="details-title">生产企业：</div>
                        <div class="details-content">云南腾药制药股份有限公司</div>
                      </div>
                    </div>
              </div>

              <div class="item-bottom">
                <div class="item1">
                  <div class="btitle">产品性状</div>
                  <div>黄色澄明液体</div>
                </div>
                <div class="bottom-line"></div>
                <div class="item2">
                  <div class="btitle">规格</div>
                  <div>2ml:100mg</div>
                </div>
                <div class="bottom-line"></div>
                <div class="item3">
                  <div class="btitle">用法用量</div>
                  <div style="width:80%;margin:0 auto">1-4支/次每日2次5天一个疗程。一般1-3 个疗程，可连续使用。</div>
                </div>
              </div>
          </div>

          <div class="content-item bounceInRight" v-show="menuIndex == 1">
              <div class="item-top">
                    <div class="item-img">
                        <img class="img3" src="../assets/images/yesuan.jpg">
                        <div class="desc">
                          温馨提示：外观包装仅供参考；请仔细阅读说明书并在医师指导下使用。
                        </div>

                        <div class="button-item" @click="onAdd">
                            立即咨询
                        </div> 
                    </div>
                    <div class="item-desc">
                      <div class="desc-title">叶酸介导上皮组织特殊染色液</div>
                      <div class="desc-tag">
                        <div class="tag">试剂</div>
                        <div class="piwen">【医疗器械备案号】辽沈械备20170097号</div>
                      </div>
                        <div class="desc-details">
                        <div class="details-title"><span>适</span><span style="flex:1;textAlign:center">应</span><span>症：</span></div>
                        <div class="details-content">适用于大部分已婚需进行宫颈癌筛查的非妊娠期妇女</div>
                      </div>

                       <div class="desc-details">
                        <div class="details-title">产品原理：</div>
                        <div class="details-content" v-if="!isShow2">是一种用于人体上皮组织肿瘤细胞的活细胞染色剂，由乙酸、叶酸衍生物、还原态亚甲蓝等组成。当染色剂被涂抹于宫颈组织后，能使细胞...<span style="color:#0EADB1;cursor: pointer" @click="onshow(2)">展开</span></div>
                        <div class="details-content" v-if="isShow2">是一种用于人体上皮组织肿瘤细胞的活细胞染色剂，由乙酸、叶酸衍生物、还原态亚甲蓝等组成。当染色剂被涂抹于宫颈组织后，能使细胞膜的通透性增加，如果有癌变细胞存在，叶酸衍生物及亚甲蓝就会迅速进入细胞浆。叶酸被还原成四氢叶酸，参与一碳单位的代谢过程。还原型的亚甲蓝则被细胞内广泛存在的活性氧氧化，变为氧化态亚甲蓝。亚甲蓝氧化后由于渗透压的改变而逸出细胞外，则可在棉签上显现出颜色。临床医生通过识别棉签颜色的变化进行判断。具有操作简便，判读容易，结果快速，成本低廉的特点，有望成为新一代宫颈癌前病变诊断的手段。
                          <span style="color:#0EADB1;cursor: pointer" @click="onhide(2)">收起</span>
                        </div>

                      </div>

                       <div class="desc-details">
                        <div class="details-title">使用方法：</div>
                        <div class="details-content" v-if="!isShow3">
                        <div>1.开启染色液，分别用大小棉签蘸取染色液适量。</div>
                        <div>2.大棉签用力涂抹宫颈五圈，再用棉签端部在宫颈口按压10秒即可取出，立即观察棉签颜....<span style="color:#0EADB1;cursor: pointer" @click="onshow(3)">展开</span></div>
                        </div>


                        <div class="details-content" v-if="isShow3">
                        <div>1.开启染色液，分别用大小棉签蘸取染色液适量。</div>
                        <div>2.大棉签用力涂抹宫颈五圈，再用棉签端部在宫颈口按压10秒即可取出，立即观察棉签颜色（包括脱脂棉和附着的粘液），以棉签颜色最深的区域和比色卡比照。</div>
                        <div>3.小棉签旋转着插入宫颈管（1.5-75px），沿颈管内壁旋转5圈逐步下拉棉签，立即观察棉签颜色（包括脱脂棉和附着的粘液），以棉签颜色最深区域和比色卡比照。
                          <span style="color:#0EADB1;cursor: pointer" @click="onhide(3)">收起</span></div>
                        </div>


                      </div>


                       <div class="desc-details">
                        <div class="details-title"><span>禁</span><span>忌：</span></div>
                        <div class="details-content" v-if="!isShow4">1.48小时内，宫颈/阴道做过清除分泌物、取分泌物、药水冲洗、消毒、上药、填塞等处理者；或48小时内进行过液基细胞学、HPV采样...<span style="color:#0EADB1;cursor: pointer" @click="onshow(4)">展开</span></div>
                      
                        <div class="details-content" v-if="isShow4">
                        <div>  1.48小时内，宫颈/阴道做过清除分泌物、取分泌物、药水冲洗、消毒、上药、填塞等处理者；或48小时内进行过液基细胞学、HPV采样者</div>
<div>2.阴道镜检查7日内、活检后一个月内、诊刮后一个月内、宫颈手术后三个月内</div>
<div>3.急性炎症期内</div>
<div>4.口服、注射用抗肿瘤药物者</div>
<div>5.已行全子宫切除手术者
 <span style="color:#0EADB1;cursor: pointer" @click="onhide(4)">收起</span>
</div>
                        </div>
                      </div>

                       <div class="desc-details">
                        <div class="details-title">规格型号</div>
                        <div class="details-content">3ML/人份</div>
                      </div>

                        <div class="desc-details">
                        <div class="details-title"><span>有</span><span style="flex:1;textAlign:center">效</span><span>期：</span></div>
                        <div class="details-content">24个月</div>
                      </div>


                       <div class="desc-details">
                        <div class="details-title">生产企业：</div>
                        <div class="details-content">辽宁钰航生物医疗科技有限公司</div>
                      </div>
                    </div>
              </div>

              <div class="item-bottom">
                <div class="item1">
                  <div class="btitle">产品性状</div>
                  <div>黄色澄明液体</div>
                </div>
                <div class="bottom-line"></div>
                <div class="item2">
                  <div class="btitle">规格</div>
                  <div>2ml:100mg</div>
                </div>
                <div class="bottom-line"></div>
                <div class="item3">
                  <div class="btitle">用法用量</div>
                  <div style="width:80%;margin:0 auto">1-4支/次每日2次5天一个疗程。一般1-3 个疗程，可连续使用。</div>
                </div>
              </div>
          </div>


        </div>
      </div>
    </div>
      <!-- 申请 -->
    <el-dialog v-model="dialogVisible" width="100%">
      <div class="apply-dialog">
        <div class="applyleft">
          <div style="margin: auto 0 auto 1.7rem; textalign: left">
            <div class="tel">致电咨询</div>
            <div class="tel-num">400-650-1132</div>
          </div>
        </div>
        <div class="applyor">OR</div>
        <div class="applyright">
          <div style="margin: auto 0.5rem; textalign: left">
            <div class="tel">让我们联系您</div>

            <div class="public-form">
              <span class="label"
                ><span style="color: red">*</span>您的身份</span
              >
              <label>
                <input
                  type="radio"
                  name="gender"
                  value="0"
                  v-model="identityType"
                />厂家
              </label>
              <label class="radiomargin">
                <input
                  type="radio"
                  name="gender"
                  value="1"
                  v-model="identityType"
                />代理商
              </label>
              <label>
                <input
                  type="radio"
                  name="gender"
                  value="2"
                  v-model="identityType"
                />个人
              </label>
            </div>

            <div class="public-form">
              <span class="label"
                ><span style="color: red">*</span>如何称呼</span
              >
              <input
                class="inputclass"
                type="text"
                name="gender"
                v-model="name"
                placeholder="烦请留下姓名以便我们联系"
              />
            </div>

            <div class="public-form">
              <span class="label"
                ><span style="color: red">*</span>联系电话</span
              >
              <input
                class="inputclass"
                type="text"
                name="gender"
                v-model="phoneNumber"
                placeholder="烦请留下电话以便我们联系"
              />
            </div>

            <div class="public-form">
              <span class="label"
                ><span style="color: red">*</span>您在哪里</span
              >
              <input
                class="inputclass"
                type="text"
                name="gender"
                v-model="addr"
                placeholder="情报诉我们您在哪里"
              />
            </div>
            <el-button
              type="primary"
              color="#4faaaf"
              round
              class="btn-style"
              style="color:white"
              @click="onsubmit"
              >提交信息</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { inject, ref, onMounted, nextTick } from "vue";
import axios from "axios";
import { useRouter } from "vue-router";
import { ElMessage } from 'element-plus'
import { WOW } from "wowjs";
export default {
  name: "Home",
  props: ["tabbarBoxFixed"],
  setup() {
    const router = useRouter();
    var menuIndex = ref(0);
    var isShow = ref(false);
    var isShow2 = ref(false);
    var isShow3 = ref(false);
    var isShow4 = ref(false);
    var dialogVisible = ref(false);


      var phoneNumber = ref("");
    var identityType = ref("0");
    var name = ref("");
    var addr = ref("");



    const menulist = ['药品','器械'];
      // 动画
      nextTick(() => {
        const wow = new WOW({
          live: false,
        });
        wow.init();
      });
    const onDetails = () => {
      router.push("/business");
    };
    const onIntroduction = () => {
      router.push("/introduction");
    };
    const onMenu = (index) =>{
      menuIndex.value = index
    }
    const onshow = (type) =>{
      if(type) {
        switch(type) {
            case 1:
            isShow.value = true;
            break;
          case 2:
            isShow2.value = true;
            break;
          case 3:
            isShow3.value = true;
            break;
          case 4:
            isShow4.value = true;
            break;
        }
      }
    }
    const onAdd = () =>{
      dialogVisible.value = true
    }
      const onsubmit = () => {
      if( phoneNumber.value == '' || name.value == '' || addr.value == '') {
               ElMessage.error('请补全联系方式')
               return false
    }

      let data = {
        phoneNumber: phoneNumber.value,
        identityType: identityType.value,
        name: name.value,
        addr: addr.value,
        source:1
      };
      axios
        .post("https://ams.e-next.cn/api/sys/intentionalConsultation/add", data)
        .then((res) => {
          console.log('res:::',res)
          if (res.data && res.data.code == 200) {
            ElMessage({
              message: "提交成功，稍后我们工作人员会联系您",
              type: "success",
            });
      dialogVisible.value = false;
          } else {
               ElMessage.error('申请失败请重试 或 拨打联系电话')
          }
        });
    };
    const onhide = (type) =>{
      if(type) {
        switch(type) {
            case 1:
            isShow.value = false;
            break;
          case 2:
            isShow2.value = false;
            break;
          case 3:
            isShow3.value = false;
            break;
          case 4:
            isShow4.value = false;
            break;
        }
      }
    }
    return {
      menulist,
      menuIndex,
      isShow,
      isShow2,
      isShow3,
      isShow4,
      dialogVisible,
       phoneNumber,
      identityType,
      name,
      addr,
      onsubmit,
      onDetails,
      onshow,
      onhide,
      onMenu,
      onIntroduction,
      onAdd
    };
  },
};
</script>
<style scoped lang="scss">
#customerChart {
  width: 2.3rem;
  height: 200px;
  position: absolute;
  left: 10%;
  bottom: 5%;
  z-index: 19;
}
.product-header {
  width: 100%;
  height: 4.1rem;
  background: #f6f6f6;
  position: relative;
  z-index: 1;
  img {
    position: absolute;
    top: 0;
    left: 0;
    height: 4.1rem;
    width: 100%;
    z-index: 11;
  }
  .title1{
    font-size: 0.3rem;
    color: black;
    position: absolute;
    top: 1.5rem;
    right: 3.24rem;
    z-index: 12;
    transform: scale(1.8,1.3);/*第一个是横向百分比，第二个是纵向百分比*/
    transition: 1s;
    font-family: pingfangB;
  }
  .title2{
    font-size: 0.11rem;
    color: black;
    position: absolute;
    top: 2rem;
    right: 2.75rem;
    font-family: pingfangM;
    z-index: 12;
    letter-spacing: 5px;
  }
  .mkdir {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba($color: #000000, $alpha: 0.5);
    z-index: 20;
    transition: 0.5s;
    opacity: 0;
  }
  .before-mkidr {
    opacity: 1;
    transition: 1s;
  }
}
.product-content{
  width: 100%;
  height: auto;
  padding:  0 0.9rem 0 0.8rem;
  box-sizing: border-box;
  margin-top: 0.4rem;
  background: #f6f6f6;
  .poduct{
    font-size: 0.3rem;
    color: #0eadb1;
    text-align: left;
    font-family: pingfang;
  }
  .menu-content{
    width: 100%;
    height: auto;
    display: flex;
    .menu{
      width: 1.81rem;
      text-align: left;
      margin-top: 0.5rem;
      .menu-text{
        font-size: 0.12rem;
        transition: 0.5s;
        margin-bottom: 0.2rem;
        cursor: pointer;
        &:hover{
          color: #00a4a7;
        }
      }
      .before-menu{
        font-size: 0.25rem;
        transition: 0.5s;
        color: #00a4a7;
      }
    }
    .line{
      width: 1px;
      height: 4rem;
        background: linear-gradient(
            to bottom,
            rgba(0,0,0,0) 0%,
            rgba(0,0,0,0) 10%,
            rgba(76,169,174,0.3) 20%,
            rgba(76,169,174,0.4) 30%,
            rgba(76,169,174,0.5) 40%,
            rgba(76,169,174,0.8) 50%,
            rgba(76,169,174,0.5) 60%,
            rgba(76,169,174,0.4) 70%,
            rgba(76,169,174,0.3) 80%,
            rgba(0,0,0,0) 90%,
            rgba(0,0,0,0) 100%)
    }
    .content {
      display: flex;
      flex:1;
      padding-top:0.4rem;
      box-sizing: border-box;
      flex-direction: column;
    }
    .content-item{
      width: 6rem;
      background: white;
      height: auto;
      margin: 0 auto 0.34rem auto;
      padding: 0.23rem;
      box-sizing: border-box;
      .item-top{
        width: 100%;
        display: flex;
        height: auto;
      }
      .item-img{
          width:1.92rem;
        .img1{
          width:1.92rem;
          height: 1.09rem;
        }
        .img2{
           width:1.92rem;
          height: 1.41rem;
        }
        .img3{
           width:1.92rem;
          height: 2.15rem;
        }
        .desc{
          font-size: 0.09rem;
          color: #000000;
          width: 100%;
          margin-top: 0.12rem;
          font-family: pingfangB;
          text-align: left;
        }
      }
      .item-desc{
        flex:1;
        margin-left: 0.2rem;
        .desc-title{
          font-size: 0.15rem;
          text-align: left;
          font-family: pingfang;
        }
        .desc-tag{
          display: flex;
          text-align: left;
          margin-top: 0.03rem;
          .tag{
            border: 1px solid #F84421;
            border-radius: 5px;
            color: #F84421;
            padding: 2px 5px;
            line-height: 0.115rem;
            height: 0.1rem;
            font-size: 0.08rem;
            text-align: center;
          }
          .piwen{
            font-size: 0.1rem;
            height: 0.1rem;
          }
       
        }
           .desc-details{
            display: flex;
            width: 100%;
            height: auto;
            margin-top: 0.08rem;
            margin-bottom: 0.15rem;
            text-align: left;
            .details-title{
              width: 0.55rem;
              text-align: left;
              display: flex;
              justify-content: space-between;
              font-size: 0.09rem;
              font-family: pingfang;
            }
            .details-content{
              font-family: pingfang;
              font-size: 0.09rem;
              flex:1
            }
          }
      }
    }
  }
}
.button-item{
  width: 0.62rem;
  height: 0.2rem;
  line-height: 0.2rem;
  border: 2px solid #0EADB1;
  background: white;
  text-align: center;
  color: #0eadb1;
  border-radius: 10px;
  font-size: 0.1rem;
  cursor: pointer;
  margin: 1rem auto 0 auto;
  &:hover{
    background: #f9f9f9;
  }
}
.item-bottom{
  width: 100%;
  display: flex;
  height: 1rem;
  // font-size: 0.112rem;
  font-size: 0.09rem;

  font-family: pingfang;
  margin-top: 0.15rem;
  .bottom-line{
    height: 0.8rem;
    width: 1px;
    margin:0;
    background: linear-gradient(
            to bottom,
            rgba(0,0,0,0) 0%,
            rgba(225,225,225,0.3) 20%,
            rgba(225,225,225,0.4) 30%,
            rgba(225,225,225,0.5) 40%,
            rgba(225,225,225,0.8) 50%,
            rgba(225,225,225,0.5) 60%,
            rgba(225,225,225,0.4) 70%,
            rgba(225,225,225,0.3) 80%,
            rgba(0,0,0,0) 100%)
  }
  .btitle{
  padding-top: 0.1rem;
  box-sizing: border-box;
    margin-bottom: 0.2rem;
  font-family: pingfangB;
  // font-size: 0.09rem;
  }
  .item1{
    text-align: center;
    height: 1rem;
    width: 20%;
  }
  .item2{
    width: 25%;
    height: 1rem;
    text-align: center;
  }
  .item3{
    flex:1;
    height: 1rem;
    text-align: center;
  }
}
.apply-dialog {
  width: 80%;
  height: 3rem;
  margin: auto;
  background: white;
  display: flex;
}
.applyleft {
  flex: 1;
  display: flex;
}
.applyright {
  flex: 1;
  display: flex;
}
.applyor {
  margin: auto;
  font-size: 0.15rem;
  color: black;
  font-family: pingfangB;
}
.tel {
  color: #4faaaf;
  font-size: 0.13rem;
  font-family: pingfang;
  text-align: left;
}
.tel-num {
  font-size: 0.2rem;
  color: black;
  font-family: pingfangB;
}
.public-form {
  margin-top: 0.2rem;
  .label {
    margin-right: 0.1rem;
    // font-size: 0.08rem;
  }
  .radiomargin {
    margin: 0 0.2rem;
  }
  .inputclass {
    width: 1.3rem;
    height: 25px;
    line-height: 25px;
    border: 1px solid #949bb3;
    border-radius: 5px;
    outline: none;
    color: #4faaaf;
    padding-left: 10px;
  }
  input[type="text"]::placeholder {
    color: #c0ccf5;
  }
}
.btn-style {
  padding: 0.08rem 0.12rem !important;
  float: left;
  margin-top: 0.2rem;
  font-size: 0.08rem;
  box-sizing: border-box;
}
</style>
